import {
    Component,
    OnInit,
    AfterViewChecked,
    AfterContentInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    NgZone,
    AfterViewInit
} from '@angular/core';
import { ShoppingcartService } from './shoppingcart.service';
import { Material } from './material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UpdateShoppingCartUseCase } from './usecase/update-shopping-cart-usecase';
import { UpdateShoppingCartUseCaseResponse } from './usecase/update-shopping-cart-usecase-response';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { RemovepackagepopupComponent } from './removepackagepopup/removepackagepopup.component';
import { GoogleTagManagerService } from '../google-tag-manager/google-tag-manager.service';
import { CalculateTotalPriceUsecase } from './usecase/calculate-total-price-usecase';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'pw-shoppingcart',
    templateUrl: './shoppingcart.component.html',
    styleUrls: ['./shoppingcart.component.scss']
})
export class ShoppingcartComponent implements OnInit, AfterViewChecked {
    isShoppingcartIconClicked = false;

    materials: Material[] = [];

    quantityOfAnItem = 1;

    totalPrice = 0;

    totalQuantity = 0;

    continueToBuyLink = 'book';

    counter = 0;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };

    isExtraSmall: Observable<BreakpointState>;

    constructor(
        private _matDialog: MatDialog,
        private _shoppingcartService: ShoppingcartService,
        private _http: HttpClient,
        private _updateShoppingCartStatusUseCase: UpdateShoppingCartUseCase,
        private _router: Router,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private readonly breakpointObserver: BreakpointObserver,
        private _googleTagManagerService: GoogleTagManagerService,
        private _calculateTotalPriceUseCase: CalculateTotalPriceUsecase
    ) {
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
    }

    ngAfterViewChecked(): void {
        if (sessionStorage.getItem('materials')) {
            this.ngZone.runOutsideAngular(() => {
                this.ref.detectChanges();
                setTimeout(() => {
                    const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                    const totalPrice = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
                    if (this.materials.length !== materials.length || this.totalPrice != totalPrice) {
                        this.materials = materials;
                        this.calculateTotalPriceAndTotalQuantity();
                        this.updateShoppingcartStatus();
                    }
                }, 0);
            });
        }

        //TODO do something else instead of checking sessionStorage.length
        if (!sessionStorage.getItem('materials')) {
            this.ngZone.runOutsideAngular(() => {
                this.ref.detectChanges();
                setTimeout(() => {
                    this.materials = [];
                    this.totalQuantity = 0;
                    this.totalPrice = 0;
                });
            });
        }
    }

    ngOnInit(): void {
        this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        this._shoppingcartService.isShoppingCartClicked = this.isShoppingcartIconClicked;
    }

    calculateTotalPriceAndTotalQuantity() {
        this._shoppingcartService.calculateTotalPrice();
        this.materials.forEach((material) => {
            this.totalQuantity += material.quantity as number;
            this.totalPrice += (material.originalPrice as number) * material.quantity!;
        });
    }
    clickToCart() {
        if (this.totalQuantity == 0) {
            alert('A kosár üres');
        } else {
            this.isShoppingcartIconClicked = true;
            this._googleTagManagerService.viewCart(this.materials);
        }
    }

    clickToCartMobile() {
        if (this.totalQuantity == 0) {
            alert('A kosár üres');
        } else {
            this._router.navigateByUrl('/cartsum');
            this._googleTagManagerService.viewCart(this.materials);
        }
    }

    closeCart() {
        this.isShoppingcartIconClicked = !this.isShoppingcartIconClicked;
    }

    removeItem(material: Material) {
        const totalPrice: number = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        if (totalPrice > 0) {
            if (!material.packageName) {
                material.quantityOfSupply! += material.quantity!;
                material.quantity = 0;
                this._shoppingcartService.removeItem(material);
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                this.materials = materials;
                this.updateShoppingcartStatus();
                window.location.reload();
            }
            if (material.packageName) {
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                let packageItemList: Material[] = [];

                materials.forEach((materialObject) => {
                    if (materialObject.packageName === material.packageName) {
                        packageItemList.push(materialObject);
                    }
                });

                this._googleTagManagerService.removePackageFromCart(packageItemList);

                materials.forEach((materialObject) => {
                    if (materialObject.packageName === material.packageName) {
                        materialObject.quantityOfSupply! += materialObject.quantity!;
                        materialObject.quantity = 0;
                        this._shoppingcartService.removeItem(materialObject);
                        const materialList = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                        this.materials = materialList;
                        this.updateShoppingcartStatus();
                        window.location.reload();
                    }
                });
            }
        }
    }

    updateShoppingcartStatus() {
        const totalPrice: number = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        const totalQuantity: number = JSON.parse(sessionStorage.getItem('totalQuantity') as string) as number;
        this.totalPrice = totalPrice;
        this.totalQuantity = totalQuantity;
    }

    increaseItemQuantity(material: Material) {
        this._shoppingcartService.increaseItemQuantity(material);
        //const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        //this.materials = materials;
        this.updateShoppingcartStatus();
    }

    decreaseItemQuantity(material: Material) {
        this._shoppingcartService.decreaseItemQuantity(material);
        //const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        //this.materials = materials;
        this.updateShoppingcartStatus();
    }

    sendObjectToMock() {
        const headers = new HttpHeaders().set('content-type', 'application/json');
        this._http.post<Material[]>('https://3ca52d5a-9607-4e9f-8513-e717b244e4c4.mock.pstmn.io/log', JSON.stringify(this.materials), {
            headers: headers
        });
    }

    goToPay() {
        this._router.navigateByUrl('/cartsum');
        this.closeCart();
    }

    loadRemovePackagePopup(selectedMaterial: Material, enterAnimationDuration: string, exitAnimationDuration: string) {
        this.dialogConfiger.data = selectedMaterial;
        const popupDialog = this._matDialog.open(RemovepackagepopupComponent, {
            data: selectedMaterial,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw'
        });
        const smallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '70vh');
            } else {
                popupDialog.updateSize('calc(50% - 50px)', '');
            }
        });
        popupDialog.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
        });
    }
}
